/* Calculator (PRO system) — sections/cs-calculator.liquid
   Mirrors the Liquid math in the section file; keep the two in sync. */
if (!customElements.get('cs-calculator')) {
  customElements.define(
    'cs-calculator',
    class CsCalculator extends HTMLElement {
      connectedCallback() {
        this.weeks = parseFloat(this.dataset.weeks) || 4.33;
        this.certCost = parseFloat(this.dataset.certificationCost) || 0;
        this.inputs = {};
        this.querySelectorAll('[data-input]').forEach((input) => {
          this.inputs[input.dataset.input] = input;
          input.addEventListener('input', () => this.update());
        });
        const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency,
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        });
        this.update();
      }

      value(key) {
        const input = this.inputs[key];
        return input ? parseFloat(input.value) || 0 : 0;
      }

      formatInput(input) {
        const v = parseFloat(input.value) || 0;
        if (input.dataset.format === 'currency') return this.money.format(v);
        if (input.dataset.format === 'percent') return `${v}%`;
        return String(v);
      }

      setText(selector, text) {
        const el = this.querySelector(selector);
        if (el && el.textContent !== text) el.textContent = text;
      }

      update() {
        Object.entries(this.inputs).forEach(([key, input]) => {
          const text = this.formatInput(input);
          input.setAttribute('aria-valuetext', text);
          this.setText(`[data-value-for="${key}"]`, text);
        });

        const treatments = this.value('treatments');
        const treatmentRevenue = treatments * this.value('price') * this.weeks;
        const retailRevenue = treatments * this.weeks * (this.value('routine') / 100) * this.value('basket');
        const retailProfit = retailRevenue * (this.value('margin') / 100);
        const weeklyProfit = retailProfit / this.weeks;

        let payback = '—';
        if (weeklyProfit > 0) {
          const weeks = Math.ceil(this.certCost / weeklyProfit);
          payback = `${weeks} ${weeks === 1 ? this.dataset.paybackUnitOne : this.dataset.paybackUnit}`;
        }

        this.setText('[data-output="total"]', this.money.format(Math.round(treatmentRevenue + retailRevenue)));
        this.setText('[data-output="treatment"]', this.money.format(Math.round(treatmentRevenue)));
        this.setText('[data-output="retail"]', this.money.format(Math.round(retailRevenue)));
        this.setText('[data-output="profit"]', this.money.format(Math.round(retailProfit)));
        this.setText('[data-output="payback"]', payback);
      }
    }
  );
}
